export const DEFAULT_FILTERS = {
  search: "",
  repartitionStatus: "all",
  gender: "all",
  discipline: "all",
  ageCategories: [],
  years: [],
  weightCategories: [],
  weightMin: "",
  weightMax: "",
};

export const PER_PAGE_OPTIONS = [50, 100, 200, 300];

export const FORMULAS = [
  { value: "", label: "Sélectionnez une formule" },
  { value: "seul_dans_distribution", label: "Seul(e) dans la distribution" },
  { value: "poule_2", label: "Poule de 2" },
  { value: "poule_3", label: "Poule de 3" },
  { value: "poule_4", label: "Poule de 4" },
  { value: "poule_5", label: "Poule de 5" },
  { value: "poule_6", label: "Poule de 6" },
  { value: "tableau_base_8", label: "Tableau sans repêchage — Base 8" },
  { value: "tableau_base_16", label: "Tableau sans repêchage — Base 16" },
  { value: "tableau_base_32", label: "Tableau sans repêchage — Base 32" },
  { value: "tableau_base_64", label: "Tableau sans repêchage — Base 64" },
  {
    value: "tableau_repechage_base_8",
    label: "Tableau avec repêchage systématique — Base 8",
  },
  {
    value: "tableau_repechage_base_16",
    label: "Tableau avec repêchage systématique — Base 16",
  },
  {
    value: "tableau_repechage_base_32",
    label: "Tableau avec repêchage systématique — Base 32",
  },
  {
    value: "tableau_repechage_base_64",
    label: "Tableau avec repêchage systématique — Base 64",
  },
  { value: "non_classes", label: "Non classés (NC) — résultats uniquement" },
];

export const FORMULA_LABELS = {
  seul_dans_distribution: "Seul(e)",
  non_classes: "NC",
  poule_2: "Poule 2",
  poule_3: "Poule 3",
  poule_4: "Poule 4",
  poule_5: "Poule 5",
  poule_6: "Poule 6",
  tableau_base_8: "Tableau 8",
  tableau_base_16: "Tableau 16",
  tableau_base_32: "Tableau 32",
  tableau_base_64: "Tableau 64",
  tableau_repechage_base_8: "Repêchage 8",
  tableau_repechage_base_16: "Repêchage 16",
  tableau_repechage_base_32: "Repêchage 32",
  tableau_repechage_base_64: "Repêchage 64",
};

export const FORMULA_MAX = {
  seul_dans_distribution: 1,
  poule_2: 2,
  poule_3: 3,
  poule_4: 4,
  poule_5: 5,
  poule_6: 6,
  tableau_base_8: 8,
  tableau_base_16: 16,
  tableau_base_32: 32,
  tableau_base_64: 64,
  tableau_repechage_base_8: 8,
  tableau_repechage_base_16: 16,
  tableau_repechage_base_32: 32,
  tableau_repechage_base_64: 64,
  non_classes: 9999,
};

export const STRICT_EXACT_FORMULAS = [
  "seul_dans_distribution",
  "poule_2",
  "poule_3",
  "poule_4",
  "poule_5",
  "poule_6",
];

export const AGE_CATEGORY_ORDER = [
  "Éveil",
  "Mini-Poussin(e)",
  "Poussin(e)",
  "Benjamin(e)",
  "Minime",
  "Cadet(te)",
  "Junior",
  "Sénior",
  "Vétéran",
  "U7",
  "U9",
  "U10",
  "U11",
  "U12",
  "U13",
  "U14",
  "U15",
  "U16",
  "U18",
  "U21",
];

export const WEIGHT_EXCLUDED_LABELS = [
  "Non pesé(e)",
  "Poids invalide",
  "Catégorie d'âge inconnue",
];